import { jwtDecode } from "jwt-decode";

class Auth {
  getUser() {
    const token = this.checkForToken();
    if (!token) return null;
    try {
      const { data } = jwtDecode(token);
      const role = localStorage.getItem("user_role");
      return { ...data, role };
    } catch (err) {
      console.error("Invalid token in getUser:", err);
      return null;
    }
  }

  loggedIn() {
    const token = this.checkForToken();
    if (!token) return false;
    try {
      const { exp } = jwtDecode(token);
      return exp > Date.now() / 1000;
    } catch (err) {
      console.error("Invalid token in loggedIn:", err);
      return false;
    }
  }

  checkForToken() {
    return localStorage.getItem("drhvac_session");
  }

  login(token) {
    localStorage.setItem("drhvac_session", token);
  }

  logout() {
    localStorage.removeItem("drhvac_session");
    localStorage.removeItem("user_role");
    window.location.assign("/");
  }
}

export default new Auth();
